import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import detector from 'i18next-browser-languagedetector'

// eslint-disable-next-line import/no-named-as-default-member
i18next
    .use(detector)
    .use(initReactI18next)
    .init({
        resources: {
            'en-GB': {
                translations: {
                    action: 'Action',
                    activate: 'Activate',
                    activation: 'Activation',
                    activationError: 'Activation Error',
                    activationSuccess:
                        'Your account has been successfully activated!',
                    accountCreated:
                        'Account created! Check your email to activate your account.',
                    actions: 'Actions',
                    addCard: 'Add a card',
                    addInCart: 'Add in cart',
                    allergens: 'Allergens',
                    alreadyHaveAccount: 'I already have an account',
                    amount: 'Amount :',
                    back: 'Back',
                    cancelledFeminine: 'Cancelled',
                    carbohydrates: 'Carbohydrates',
                    cardRefused: 'Pre-authorization declined by your bank.',
                    cardRegistered: 'Card successfully registered!',
                    cart: 'Cart',
                    cartDiscountYes: 'Cart discount : yes',
                    cartEmpty: 'Your cart is empty',
                    cash: 'Cash',
                    changeAmount: 'Change amount',
                    chooseAFile: 'Choose a file…',
                    chooseProducts: 'Choose products',
                    confirmDeletionText:
                        'Are you sure you want to delete it permanently?',
                    confirmDeletionTitle: 'Confirmation of deletion',
                    confirm: 'Confirm',
                    confirmation: 'Confirmation',
                    cooking: 'Cooking',
                    cookingTemperature: 'Cooking temperature : ',
                    cookingTime: 'Cooking time : ',
                    contact: 'contact',
                    contactless: 'contactless',
                    create: 'Create',
                    created: 'Successfully created!',
                    createAccount: 'Create an account',
                    credit: 'Credit',
                    creditCard: 'Credit card',
                    date: 'Date',
                    delete: 'Delete',
                    deleted: 'Successfully deleted!',
                    delivery: 'Delivery',
                    deliverySite: 'Delivery site',
                    description: 'Description',
                    discounts: 'Discounts',
                    displayNumber: 'Number {{number}}',
                    disputed: 'Disputed',
                    disputes: 'Disputes',
                    domainNameNotAuthorised:
                        'This domain name is not authorised.',
                    email: 'Email',
                    emailAlreadyUsed: 'Email already used.',
                    emailOrPasswordIncorrect: 'Incorrect e-mail or password.',
                    employerContribution: 'Employer contribution :',
                    empty: 'Empty',
                    english: 'English',
                    energyKcal: 'Energy (kcal)',
                    energyKj: 'Energy (kJ)',
                    errorActivationToken: 'Invalid activation token',
                    errorTryLater:
                        'An error has occurred, please try again later.',
                    expiredFeminine: 'Expired',
                    fat: 'Fat',
                    fibres: 'Fibres',
                    fill: 'Fill',
                    firstName: 'First name',
                    forgottenPassword: 'Password forgotten?',
                    french: 'French',
                    globalInformation: 'Global information',
                    goToCart: 'Go to cart',
                    iAcceptTos: 'I accept the ToS.',
                    information: 'Information',
                    inPreparation: 'In preparation',
                    lastName: 'Last name',
                    login: 'Login',
                    loginRedirection:
                        'You will be redirected to the login page in a few seconds…',
                    logout: 'Logout',
                    machineNotFound: 'The machine has not been found.',
                    makeOrder: 'Make an order',
                    mealVoucher: 'Meal voucher',
                    menus: 'Menus',
                    modify: 'Modify',
                    name: 'Name',
                    needsCreditCard:
                        'To be able to consume on our machines, add a valid credit card.',
                    newPassword: 'New password',
                    next: 'Next',
                    noFileChosen: 'No file chosen.',
                    noInformation: 'No information',
                    noOrderAvailable: 'No order available',
                    noProduct: 'No product',
                    noPurchaseFound: 'No purchase found.',
                    noRefillFound: 'No refill found.',
                    noValidCard: 'No valid card',
                    number: 'Number',
                    nutritionalValues: 'Nutritional values',
                    oldPassword: 'Old password',
                    oldPasswordIncorrect: 'The old password is incorrect.',
                    onDelivery: 'On delivery',
                    open: 'Open',
                    opened: 'Successfully opened!',
                    order: 'Order',
                    orderAlreadyRetrieved: 'Order already retrieved',
                    ordersInProgress: 'Orders in progress',
                    orderNumber: 'Order {{number}}',
                    orderSummary: 'Order summary',
                    orders: 'Orders',
                    password: 'Password',
                    passwordConfirmation: 'Password confirmation',
                    passwordMustBeStronger: 'The password must be stronger.',
                    passwordsMustBeIdentical: 'Passwords must be identical.',
                    phoneNumber: 'Phone number',
                    previous: 'Previous',
                    price: 'Price',
                    priceWeight: 'Price per weight',
                    privateCard: 'Private card',
                    privateCardAlreadyUsed: 'Private card already used.',
                    privateCardNotFound: 'Private card not found.',
                    privateCardNumber: 'Badge / private card number',
                    product: 'Product',
                    products: 'Products',
                    productsPurchased: 'Products purchased',
                    proteins: 'Proteins',
                    purchase: 'Purchase',
                    purchaseDetails: 'Purchase details',
                    purchases: 'Purchases',
                    quantity: 'Quantity',
                    readyFeminine: 'Ready',
                    redirection:
                        'You will be redirected to the login page in a few seconds…',
                    refill: 'Refill',
                    refillHistory: 'Refill history',
                    refilling: 'Refilling',
                    refills: 'Refills',
                    register: 'Register',
                    removedFeminine: 'Removed',
                    reset: 'Reset',
                    resetPassword: 'Reset password',
                    resetPasswordInstruction:
                        'Enter your e-mail address. You will receive a link to reset your password.',
                    retrievedFeminine: 'Retrieved',
                    salt: 'Salt',
                    saturatedFattyAcid: 'of which saturated fatty acids',
                    save: 'Save',
                    selectSiteDelivery: 'Select a site for delivery',
                    site: 'Site',
                    spanish: 'Spanish',
                    status: 'Status',
                    step: 'Step',
                    steps: 'Steps',
                    stocks: 'Stocks',
                    send: 'Send',
                    sent: 'Successfully sent!',
                    sugar: 'of which sugars',
                    terminal: 'Terminal',
                    termsOfService: 'Terms of Service',
                    total: 'Total',
                    updated: 'Successfully updated!',
                    unity: 'unity',
                    vat: 'VAT',
                    wantsDiscounts: 'I would like to receive special offers.',
                    wantsMarketing: 'I would like to receive targeted emails.',
                    wantsNewsletters: 'I would like to receive newsletters.',

                    // Old
                    add: 'Add',
                    firstTimeText:
                        'To use the machines, please add a credit card.',
                    welcome: 'Welcome !',
                    'Forgot Password?': 'Forgot Password?',
                    'First name': 'First name',
                    'Last name': 'Last name',
                    Username: 'Username',
                    'E-mail': 'E-mail',
                    'Sign up': 'Sign up',
                    'Sign in': 'Sign in',
                    French: 'French',
                    English: 'English',
                    Spanish: 'Spanish',
                    'Live Customize': 'Live Customize',
                    Language: 'Language',
                    'Enter your credentials to continue':
                        'Enter your credentials to continue',
                    'Hi, Welcome Back': 'Hi, Welcome Back',
                    'Create your Konvive account':
                        'Create your Konvive account',
                    Dashboard: 'Dashboard',
                    Contestation: 'Disputes',
                    History: 'History',
                    Name: 'Name',
                    Price: 'Price',
                    refillAlready: 'A refill is in progress, please wait.',
                    supply: 'supply',
                    punctual: 'Punctual reloading',
                    refillCard: 'Refill private card',
                    registerError:
                        'An error has occurred while registering your card ',
                    searchProducts: 'Search products',
                    successRefill:
                        'Your refill request has been successfully processed',
                    failedRefill:
                        'Your refill request failed, please try again',
                    paymentSuccess: 'Your refill has been successfull',
                    paymentFailed: 'Your refill has been refused',
                    Disputes: 'Disputes',
                    'Good Morning': 'Good Morning',
                    Logout: 'Logout',
                    'Account Settings': 'Account Settings',
                    'Create new account': 'Create new account',
                },
            },

            'fr-FR': {
                translations: {
                    action: 'Action',
                    activate: 'Activer',
                    activation: 'Activation',
                    activationError: 'Erreur d’activation',
                    activationSuccess:
                        'Votre compte a été activé avec succès !',
                    accountCreated:
                        'Compte créé ! Regardez vos courriels pour activer votre compte.',
                    actions: 'Actions',
                    addCard: 'Ajouter une carte',
                    addInCart: 'Ajouter au panier',
                    allergens: 'Allergènes',
                    alreadyHaveAccount: 'J’ai déjà un compte',
                    amount: 'Montant :',
                    back: 'Retour',
                    cancelledFeminine: 'Annulée',
                    carbohydrates: 'Glucides',
                    cardRefused: 'Pré-autorisation refusée par votre banque.',
                    cardRegistered: 'Carte enregistrée avec succès !',
                    cart: 'Panier',
                    cartDiscountYes: 'Réduction panier : oui',
                    cartEmpty: 'Votre panier est vide',
                    cash: 'Espèce',
                    changeAmount: 'Changer de montant',
                    chooseAFile: 'Choisir un fichier…',
                    chooseProducts: 'Choisir des produits',
                    confirmDeletionText:
                        'Êtes-vous sûr de supprimer définitivement ?',
                    confirmDeletionTitle: 'Confirmation de la suppression',
                    confirm: 'Confirmer',
                    confirmation: 'Confirmation',
                    cooking: 'Cuisson',
                    cookingTemperature: 'Température de cuisson : ',
                    cookingTime: 'Temps de cuisson : ',
                    contact: 'avec contact',
                    contactless: 'sans contact',
                    create: 'Créer',
                    created: 'Créé avec succès !',
                    createAccount: 'Créer un compte',
                    credit: 'Crédit',
                    creditCard: 'Carte de crédit',
                    date: 'Date',
                    delete: 'Supprimer',
                    deleted: 'Supprimé avec succès !',
                    delivery: 'Livraison',
                    deliverySite: 'Site de livraison',
                    description: 'Description',
                    discounts: 'Réductions',
                    displayNumber: 'Numéro {{number}}',
                    disputed: 'Contesté',
                    disputes: 'Contestations',
                    domainNameNotAuthorised:
                        'Ce nom de domaine n’est pas autorisé.',
                    email: 'Courriel',
                    emailAlreadyUsed: 'Courriel déjà utilisé.',
                    emailOrPasswordIncorrect:
                        'Courriel ou mot de passe incorrect.',
                    employerContribution: 'Participation employeur :',
                    empty: 'Vide',
                    english: 'Anglais',
                    energyKcal: 'Énergie (kcal)',
                    energyKj: 'Énergie (kJ)',
                    errorActivationToken: 'Jeton d’activation invalide',
                    errorTryLater:
                        'Une erreur est survenue, veuillez réessayer plus tard.',
                    expiredFeminine: 'Expirée',
                    fat: 'Matières grasses',
                    fibres: 'Fibres',
                    fill: 'Plein',
                    firstName: 'Prénom',
                    french: 'Français',
                    forgottenPassword: 'Mot de passe oublié ?',
                    globalInformation: 'Informations globales',
                    goToCart: 'Aller au panier',
                    iAcceptTos: 'J’accepte les CGU.',
                    information: 'Informations',
                    inPreparation: 'En préparation',
                    lastName: 'Nom',
                    login: 'Connexion',
                    loginRedirection:
                        'Vous serez redirigé vers la page de connexion dans quelques secondes…',
                    logout: 'Déconnexion',
                    machineNotFound: 'La machine n’a pas été trouvée.',
                    makeOrder: 'Passer une commande',
                    mealVoucher: 'Ticket restaurant',
                    menus: 'Menus',
                    modify: 'Modifier',
                    name: 'Nom',
                    needsCreditCard:
                        'Afin de pouvoir consommer sur nos machines, veuillez ajouter une carte de crédit valide.',
                    newPassword: 'Nouveau mot de passe',
                    next: 'Suivant',
                    noFileChosen: 'Aucun fichier choisi.',
                    noInformation: 'Non renseigné',
                    noProduct: 'Aucun produit disponible',
                    noOrderAvailable: 'Aucune commande disponible',
                    noPurchaseFound: 'Aucun achat trouvé.',
                    noRefillFound: 'Aucun rechargement trouvé.',
                    noValidCard: 'Pas de carte valide',
                    number: 'Numéro',
                    nutritionalValues: 'Valeurs nutritionnelles',
                    oldPassword: 'Ancien mot de passe',
                    oldPasswordIncorrect:
                        'L’ancien mot de passe est incorrect.',
                    onDelivery: 'En livraison',
                    open: 'Ouvrir',
                    opened: 'Ouvert avec succès !',
                    order: 'Commande',
                    orderAlreadyRetrieved: 'Commande déjà récupérée',
                    ordersInProgress: 'Commandes en cours',
                    orderNumber: 'Commande {{number}}',
                    orderSummary: 'Récapitulatif commande',
                    orders: 'Commandes',
                    password: 'Mot de passe',
                    passwordConfirmation: 'Confirmation mot de passe',
                    passwordMustBeStronger:
                        'Le mot de passe doit être plus robuste.',
                    passwordsMustBeIdentical:
                        'Les mots de passe doivent être identiques.',
                    phoneNumber: 'Numéro de téléphone',
                    previous: 'Précédent',
                    price: 'Prix',
                    priceWeight: 'Prix au poids',
                    privateCard: 'Carte privative',
                    privateCardAlreadyUsed: 'Carte privative déjà utilisée.',
                    privateCardNotFound: 'Carte privative introuvable.',
                    privateCardNumber: 'Numéro de badge / carte privative',
                    product: 'Produit',
                    products: 'Produits',
                    productsPurchased: 'Produits achetés',
                    proteins: 'Protéines',
                    purchase: 'Achat',
                    purchaseDetails: 'Détails de l’achat',
                    purchases: 'Achats',
                    quantity: 'Quantité',
                    readyFeminine: 'Prête',
                    redirection:
                        'Vous serez redirigé vers la page de connexion dans quelques secondes…',
                    refill: 'Recharger',
                    refillHistory: 'Historique des rechargements',
                    refilling: 'Rechargement',
                    refills: 'Rechargements',
                    register: 'Inscription',
                    removedFeminine: 'Supprimée',
                    reset: 'Réinitialiser',
                    resetPassword: 'Réinitialision mot de passe',
                    resetPasswordInstruction:
                        'Veuillez renseigner votre courriel. Vous recevrez un lien pour réinitialiser votre mot de passe.',
                    retrievedFeminine: 'Retirée',
                    salt: 'Sel',
                    saturatedFattyAcid: 'dont acides gras saturés',
                    save: 'Sauvegarder',
                    selectSiteDelivery: 'Sélectionner un site de livraison',
                    site: 'Site',
                    spanish: 'Espagnol',
                    status: 'Statut',
                    step: 'Étape',
                    steps: 'Étapes',
                    stocks: 'Stocks',
                    send: 'Envoyer',
                    sent: 'Envoyé avec succès !',
                    sugar: 'dont sucres',
                    terminal: 'Borne',
                    termsOfService: 'Conditions générales d’utilisation',
                    total: 'Total',
                    updated: 'Mis à jour avec succès !',
                    unity: 'unité',
                    vat: 'TVA',
                    wantsDiscounts: 'Je souhaite recevoir les promotions.',
                    wantsMarketing:
                        'Je souhaite recevoir des courriels ciblés.',
                    wantsNewsletters:
                        'Je souhaite recevoir les bulletins d’information.',

                    // Old
                    add: 'Ajouter',
                    firstTimeText:
                        'Afin de consommer sur les machines, veuillez ajouter une carte de crédit.',
                    welcome: 'Bienvenue !',
                    'Forgot Password?': 'Mot de passe oublié?',
                    'First name': 'Prénom',
                    'Last name': 'Nom',
                    Username: 'Identifiant',
                    'E-mail': 'E-mail',
                    'Sign up': 'Créer compte',
                    'Sign in': 'Connexion',
                    French: 'Français',
                    English: 'Anglais',
                    Spanish: 'Espagnol',
                    'Live Customize': 'Customisation en live',
                    Language: 'Langue',
                    Name: 'Nom',
                    Price: 'Prix',
                    Description: 'Description',
                    'Create your Konvive account': 'Crée votre compte Konvive',
                    'Enter your credentials to continue':
                        'Connectez vous pour continuer',
                    'Hi, Welcome Back':
                        'Bonjour ! Bienvenue dans votre Espace Konvive',
                    Dashboard: 'Tableau de bord',
                    History: 'Historique',
                    'Stock Machine': ' Stocks des Machines',
                    'Select a machine': 'Séléctionnez une machine',
                    Disputes: 'Contestations',
                    'Good Morning': 'Bonjour',
                    Logout: 'Déconnexion',
                    'Account Settings': 'Paramètres compte',
                    'Create new account': 'Créer un nouveau compte',
                    'Account created. Please check your mail to activate your account.':
                        'Compte créé. Veuillez vérifier votre courrier pour activer votre compte',
                    'Name card': 'Nom carte',
                    'Card number': 'Numéro de carte',
                    'Expiration date': 'Date d’expiration',
                    'EXPIRATION MONTH': 'MOIS D’EXPIRATION',
                    'EXPIRATION YEAR': 'ANNEE D’EXPIRATION',
                    'Add Card': 'Ajouter la carte',
                    CVV: 'CVV',
                    'Import a card to continue':
                        'Importez une carte bancaire pour continuer',
                    'Save card': 'Enregistrer carte',
                    'Paid with': 'Payé par',
                    'No menu/promo for this sale':
                        'Aucun menu/promo pour cette vente',
                    Products: 'Produits',
                    ' products': ' produits',
                    '1 product': '1 produit',
                    VAT: 'TVA',
                    'Previous credit': 'Crédit précédent',
                    'Current credit': 'Crédit actuel',
                    'Client number': 'Numéro de client',
                    'Contact less': 'Sans contact',
                    'Credit card': 'Carte bancaire',
                    'Mobile app': 'App mobile',
                    '30$': '30€',
                    '40$': '40€',
                    '50$': '50€',
                    '100$': '100€',
                    'Private card': 'Carte privative',
                    'Digital luncheon voucher': 'TRD',
                    'Sale details': 'Détails vente',
                    'See dispute': 'Voir contestation',
                    'Sales history': 'Historique des ventes',
                    'Refills history': 'Historique des rechargements',
                    refillCard: 'Recharger la carte privative',
                    refillAlready:
                        'Un rechargement est en cours, veuillez patienter.',
                    Reload: 'Recharger',
                    registerError:
                        'Une erreur s’est produite lors de l’enregistrement de votre carte',
                    searchProducts: 'Rechercher des produits',
                    successRefill:
                        'Votre demande de rechargement a été traitée avec succès',
                    failedRefill:
                        'Votre demande de rechargement a échoué, veuillez réessayer',
                    paymentSuccess:
                        'Votre recharge a été effectuée avec succès',
                    paymentFailed: 'Votre recharge a été refusée',
                    punctual: 'Rechargement ponctuel',
                    'Your refill request has been successfully processed':
                        'Votre demande de rechargement a été effectué avec succès',
                    'Your payment failed, please try again':
                        'Votre paiement a échoué, veuillez Réessayer',
                    'Bonus of 12$': 'Bonus de 12€',
                    'Bonus of 5$': 'Bonus de 5€',
                    discounted: 'de réduction',
                    'Refill amount': 'Montant rechargement',
                    'Current total credit': 'Crédit total actuel',
                    'See more': 'Voir plus',
                    and: 'et',
                    'in participation': 'en participation',
                    'Total product bought': 'Nombre de produits achetés',
                    'Total money spent': 'Argent total dépensé',
                    'Total sales': 'Nb de transactions',
                    'No sale found': 'Aucune transaction trouvée',
                    'Payment methods list': 'Liste méthodes de paiement',
                    'Add payment method': 'Ajouter méthode de paiement',
                    'Meal voucher Conecs': 'TRD',
                    Profile: 'Profil',
                    'Save details': 'Enregistrer',
                    'Reset password': 'Réinitialiser mot de passe',
                    'Account from': 'Compte de',
                    'Phone number': 'Numéro de téléphone',
                    'E-mail address': 'Adresse e-mail',
                    'Upload picture': 'Importer une photo',
                    'Add a payment method': 'Ajouter une méthode de paiement',
                    'After refund credit': 'Crédit après remboursement',
                    'Before refund credit': 'Crédit avant remboursement',
                    'Are you sure you want to delete this payment method ?':
                        'Êtes-vous sûr de vouloir supprimer cette méthode de paiement ?',
                    Delete: 'Supprimer',
                    Cancel: 'Annuler',
                    Close: 'Fermer',
                    Reason: 'Raison',
                    'Your card has been registered.':
                        'Votre carte à bien été enrtegister.',
                    Refund: 'Remboursement',
                    Hello: 'Bonjour',
                    'Created successfully': 'Créé avec succès',
                    'Updated successfully': 'Mis à jour avec succès',
                    'Deleted successfully': 'Supprimé avec succès',
                    'Selected Product Details':
                        'Détails du produit sélectionné',
                    'After refill credit': 'Crédit après rechargement',
                    'I’m willing to receive every week the newsletter from ':
                        'Je souhaite recevoir chaque semaine la newsletter de ',
                    'I’m willing to receive punctual promotions (sales, operations, Antiwaste)':
                        'Je souhaite recevoir des promotions ponctuelles (soldes, opérations, Antigaspi…).',
                    'I’m willing to receive targeted emails according to my browsing data and my interests':
                        'Je souhaite recevoir des emails ciblés en fonction de mes données de navigation et mes intérêts.',
                    'No dispute found': 'Aucune contestation trouvée',
                    'Old password': 'Ancien mot de passe',
                    'New password': 'Nouveau mot de passe',
                    'Reset your password': 'Réinitialiser votre mot de passe',
                    'Confirm password': 'Confirmation nouveau mot de passe',
                    'Please validate the login request by clicking the button':
                        'Veuillez cliquer sur le bouton pour valider la demande de connexion',
                    'Send connection request': 'Envoyer demande de connexion',
                    'Logged in to machine successfully! You are being redirected to the app…':
                        'Connexion à la machine réussie! Nous vous redirigeons vers l’application…',
                    'You need to register at least one paiement method to use the app.':
                        'Vous devez enregistrer au moins une méthode de paiement pour utiliser l’app.',
                    'Unable to registered your card, please check the information. Please try again.':
                        'Impossible d’enregistrer votre carte, veuillez vérifier les informations. Veuillez réessayer.',
                    'No refill found': 'Aucun rechargement trouvé',
                    Payment: 'Paiement',
                    'Invalid card': 'Carte invalide',
                    'Contact operator of this sale':
                        'Contacter le gestionnaire de cette vente',
                    'The application cannot find which client you are trying to create an account for. Please initiate the creation via a QR code or a link sent to you by an operator.':
                        'L’application ne peut trouver de client auquel vous relier. Veuillez initier la création depuis un QR code ou un lien envoyé par un gestionnaire.',
                },
            },

            'es-ES': {
                translations: {
                    action: 'Acción',
                    activate: 'Activar',
                    activation: 'Activación',
                    activationError: 'Error de activación',
                    activationSuccess:
                        '¡Tu cuenta ha sido activada exitosamente!',
                    accountCreated:
                        '¡Cuenta creada! Compruebe su correo electrónico para activar su cuenta.',
                    actions: 'Acciones',
                    addCard: 'Añadir una tarjeta',
                    addInCart: 'Añadir al carrito',
                    allergens: 'Alergias',
                    alreadyHaveAccount: 'Ya tengo una cuenta',
                    amount: 'Importe:',
                    back: 'Volver',
                    cancelledFeminine: 'Cancelada',
                    carbohydrates: 'Carbohidratos',
                    cardRefused: 'Preautorización rechazada por su banco.',
                    cardRegistered: '¡Tarjeta registrada con éxito!',
                    cart: 'Cesta',
                    cartDiscountYes: 'Descuento cesta: sí',
                    cartEmpty: 'Tu cesta está vacía',
                    cash: 'Effectivo',
                    changeAmount: 'Modificar importe',
                    chooseAFile: 'Elige un archivo…',
                    chooseProducts: 'Elige los productos',
                    confirmDeletionText:
                        '¿Seguro que quieres borrarlo definitivamente?',
                    confirmDeletionTitle: 'Confirmación de la supresión',
                    confirm: 'Confirmar',
                    confirmation: 'Confirmación',
                    contact: 'por contacto',
                    cooking: 'Cocción',
                    cookingTemperature: 'Temperatura de cocción : ',
                    cookingTime: 'Tiempo de cocción : ',
                    contactless: 'sin contacto',
                    create: 'Crear',
                    created: '¡Creado con éxito!',
                    createAccount: 'Crear una cuenta',
                    credit: 'Crédito',
                    creditCard: 'Tarjeta de crédito',
                    date: 'Fecha',
                    delete: 'Borrar',
                    deleted: '¡Borrado con éxito!',
                    delivery: 'Entrega',
                    deliverySite: 'Sitio de entrega',
                    description: 'Descripción',
                    discounts: 'Reducciones',
                    displayNumber: 'Número {{number}}',
                    disputed: 'Disputado',
                    disputes: 'Disputas',
                    domainNameNotAuthorised:
                        'Este nombre de dominio no está autorizado.',
                    email: 'Correo electrónico',
                    emailAlreadyUsed: 'Correo electrónico ya en uso.',
                    emailOrPasswordIncorrect:
                        'Correo electrónico o contraseña incorrecto.',
                    employerContribution: 'Contribución patronal:',
                    empty: 'Vacío',
                    english: 'Inglés',
                    energyKcal: 'Energía (kcal)',
                    energyKj: 'Energía (kJ)',
                    errorActivationToken: 'Ficha de activación inválida',
                    errorTryLater:
                        'Se ha producido un error, inténtelo de nuevo más tarde.',
                    expiredFeminine: 'Expirada',
                    fat: 'Grasas y aceites',
                    fibres: 'Fibras',
                    fill: 'Lleno',
                    firstName: 'Apellidos',
                    french: 'Francés',
                    forgottenPassword: '¿Olvidó su contraseña?',
                    globalInformation: 'Información global',
                    goToCart: 'Ir a la cesta',
                    iAcceptTos: 'Acepto las condiciones generales.',
                    information: 'Información',
                    inPreparation: 'En preparación',
                    lastName: 'Nombre',
                    login: 'Conexión',
                    loginRedirection:
                        'Serás redirigido/a a la página de inicio de sesión en unos segundos…',
                    logout: 'Desconexión',
                    machineNotFound: 'La máquina no ha sido encontrada.',
                    makeOrder: 'Realizar pedido',
                    mealVoucher: 'Vale de comida',
                    menus: 'Menús',
                    modify: 'Modificar',
                    name: 'Nombre',
                    needsCreditCard:
                        'Para poder consumir en nuestras máquinas, añada una tarjeta de crédito válida.',
                    newPassword: 'Nueva contraseña',
                    next: 'Siguiente',
                    noFileChose: 'No hay ficheros seleccionados.',
                    noInformation: 'No hay información',
                    noProduct: 'No productos disponibles',
                    noOrderAvailable: 'No hay pedidos disponibles',
                    noPurchaseFound: 'No se encontraron compras.',
                    noRefillFound: 'No se encontraron recargas.',
                    noValidCard: 'Sin tarjeta válida',
                    number: 'Número',
                    nutritionalValues: 'Valores nutricionales',
                    oldPassword: 'Contraseña antigua',
                    oldPasswordIncorrect:
                        'La contraseña antigua es incorrecta.',
                    onDelivery: 'En entrega',
                    open: 'Abrir',
                    opened: '¡Abierto con éxito!',
                    order: 'Pedido',
                    orderAlreadyRetrieved: 'Pedido ya recuperado',
                    ordersInProgress: 'Pedidos en curso',
                    orderNumber: 'Pedido {{number}}',
                    orderSummary: 'Resumen del pedido',
                    orders: 'Pedidos',
                    password: 'Contraseña',
                    passwordConfirmation: 'Confirmar contraseña',
                    passwordMustBeStronger:
                        'La contraseña debe ser más segura.',
                    passwordsMustBeIdentical:
                        'Las contraseñas deben ser idénticas.',
                    phoneNumber: 'Número de teléfono',
                    previous: 'Anterior',
                    price: 'Precio',
                    priceWeight: 'Precio por peso',
                    privateCard: 'Tarjeta privada',
                    privateCardAlreadyUsed: 'Tarjeta privada ya en uso.',
                    privateCardNotFound: 'Tarjeta privada no encontrada.',
                    privateCardNumber: 'Número de placa / tarjeta privada',
                    product: 'Producto',
                    products: 'Productos',
                    productsPurchased: 'Productos adquiridos',
                    proteins: 'Proteínas',
                    purchase: 'Compra',
                    purchaseDetails: 'Detalles de la compra',
                    purchases: 'Compras',
                    quantity: 'Cantidad',
                    readyFeminine: 'Listo',
                    redirection:
                        'En unos segundos se le redirigirá a la página de conexión…',
                    refill: 'Recargar',
                    refillHistory: 'Recargar historial',
                    refilling: 'Recargado',
                    refills: 'Recargas',
                    register: 'Inscripción',
                    removedFeminine: 'Eliminado',
                    reset: 'Restablecer',
                    resetPassword: 'Restablecer contraseña',
                    resetPasswordInstruction:
                        'Introduzca su dirección de correo electrónico. Recibirá un enlace para restablecer su contraseña.',
                    retrievedFeminine: 'Recuperado',
                    salt: 'Sal',
                    saturatedFattyAcid: 'de los cuales ácidos grasos saturados',
                    save: 'Guardar',
                    selectSiteDelivery: 'Seleccionar un sitio de entrega',
                    site: 'Sitio',
                    spanish: 'Español',
                    status: 'Estado',
                    step: 'Paso',
                    steps: 'Pasos',
                    stocks: 'Stocks',
                    send: 'Enviar',
                    sent: '¡Enviado con éxito!',
                    sugar: 'de los cuales azúcares',
                    terminal: 'Terminal',
                    termsOfService: 'Condiciones generales de uso',
                    total: 'Total',
                    updated: '¡Actualizado con éxito!',
                    unity: 'Unidad',
                    vat: 'IVA',
                    wantsDiscounts: 'Me gustaría recibir ofertas especiales.',
                    wantsMarketing:
                        'Me gustaría recibir correos electrónicos específicos.',
                    wantsNewsletters:
                        'Me gustaría recibir boletines informativos.',

                    // Old
                    add: 'Añadir',
                    firstTimeText:
                        'Para utilizar las máquinas, añada una tarjeta de crédito.',
                    welcome: 'Bienvenido !',
                    'Forgot Password?': '¿Olvidó su contraseña?',
                    'First name': 'Nombre de pila',
                    'Last name': 'Apellido',
                    Username: 'Nombre de usuario',
                    Credit: 'Crédito',
                    'E-mail': 'Correo electrónico',
                    'Transaction #': 'Transacción #',
                    Send: 'Envíe',
                    'Type your message here': 'Escriba aquí su mensaje',
                    'Sign up': 'Registrarse',
                    'Sign in': 'Iniciar sesión',
                    French: 'Francés',
                    English: 'Inglés',
                    Spanish: 'Español',
                    'Live Customize': 'Personalización en vivo',
                    Language: 'Idioma',
                    'Enter your credentials to continue':
                        'Ingrese sus credenciales para continuar',
                    'Hi, Welcome Back': '¡Hola, bienvenido de nuevo!',
                    Dashboard: 'Tablero de control',
                    Contestation: 'Disputa',
                    History: 'Historial',
                    Disputes: 'Disputas',
                    'Good Morning': 'Buenos días',
                    Logout: 'Cerrar sesión',
                    'Account Settings': 'Configuración de la cuenta',
                    'Create new account': 'Crear una nueva cuenta',
                    'Account created. Redirecting to login.':
                        'Cuenta creada. Redireccionando a la página de inicio de sesión',
                    'Name card': 'Nombre de la tarjeta',
                    'Card number': 'Número de tarjeta',
                    'Expiration date': 'Fecha de vencimiento',
                    CVV: 'CVV',
                    'Import a card to continue':
                        'Importar una tarjeta para continuar',
                    'Save card': 'Guardar tarjeta',
                    'Paid with': 'Pagado con',
                    'No menu/promo for this sale':
                        'Sin menú/promoción para esta venta',
                    Products: 'Productos',
                    ' products': ' productos',
                    '1 product': '1 producto',
                    VAT: 'IVA',
                    Name: 'Nombre',
                    Price: 'Precios',
                    Description: 'Descripción',
                    'Selected Product Details':
                        'Detalles del producto seleccionado',
                    'Stock Machine': 'Existencias de maquinaria',
                    'Select a machine': 'Seleccione una máquina',
                    'Previous credit': 'Crédito anterior',
                    'Current credit': 'Crédito actual',
                    'Client number': 'Número de cliente',
                    'Contact less': 'Sin contacto',
                    'Credit card': 'Tarjeta de crédito',
                    'Mobile app': 'Aplicación móvil',
                    'Private card': 'Tarjeta privada',
                    'Digital luncheon voucher': 'Vale de almuerzo digital',
                    'Sale details': 'Detalles de venta',
                    '30$': '30€',
                    '40$': '40€',
                    '50$': '50€',
                    '100$': '100€',
                    'See dispute': 'Ver disputa',
                    'Sales history': 'Historial de ventas',
                    'Purchase history': 'Historial de compras',
                    'Refills history': 'Historial de recargas',
                    discounted: 'con descuento',
                    'Refill amount': 'Cantidad de recarga',
                    'Current total credit': 'Crédito total actual',
                    'See more': 'Ver más',
                    refillCard: 'Recargar tarjeta privada',
                    refillAlready: 'Recarga en curso, por favor espere.',
                    and: 'y',
                    'in participation': 'en participación',
                    'Total product bought': 'Total de productos comprados',
                    'Total money spent': 'Dinero total gastado',
                    'Total sales': 'Ventas totales',
                    'Account created. Please check your mail to activate your account':
                        'Cuenta creada. Por favor, compruebe su correo para activar su cuenta',
                    'No sale found': 'No se encontraron ventas',
                    'Payment methods list': 'Lista de métodos de pago',
                    'Add a payment method': 'Añadir un método de pago',
                    'Add payment method': 'Agregar método de pago',
                    'Meal voucher Conecs': 'Vale de comida Conecs',
                    Profile: 'Perfil',
                    'Save details': 'Guardar detalles',
                    'Reset password': 'Restablecer contraseña',
                    'Account from': 'Cuenta de',
                    'Phone number': 'Número de teléfono',
                    'E-mail address': 'Dirección de correo electrónico',
                    'Upload picture': 'Cargar imagen',
                    'After refund credit': 'Crédito después de reembolso',
                    'Before refund credit': 'Crédito antes de reembolso',
                    Reason: 'Motivo',
                    Refund: 'Reembolso',
                    Close: 'Cerrar',
                    'Are you sure you want to delete this payment method ?':
                        '¿Estás seguro de que deseas eliminar este método de pago?',
                    Delete: 'Eliminar',
                    Cancel: 'Cancelar',
                    'Your card has been registered.':
                        'Tu tarjeta ha sido registrada.',
                    Hello: 'Hola',
                    Refill: 'Recarga',
                    registerError:
                        'Se ha producido un error al registrar su tarjeta',
                    searchProducts: 'Buscar productos',
                    successRefill:
                        'Su solicitud de recarga se ha procesado correctamente',
                    failedRefill:
                        'Su pago ha fallado, por favor inténtelo de nuevo',
                    paymentSuccess: 'Su recarga se ha completado con éxito',
                    paymentFailed: 'Su recarga ha sido rechazada',
                    Reload: 'Recarga',
                    punctual: 'Recarga puntual',
                    'Your refill request has been successfully processed':
                        'Su solicitud de recarga se ha tramitado correctamente',
                    'Your payment failed, please try again':
                        'Su pago falló, por favor inténtelo de nuevo',
                    'Bonus of 12$': 'Bono de 12€',
                    'Bonus of 5$': 'Bono de 5€',
                    'Created successfully': 'Creado exitosamente',
                    'Updated successfully': 'Actualizado exitosamente',
                    'Deleted successfully': 'Eliminado exitosamente',
                    'After refill credit': 'Crédito después de recarga',
                    'I’m willing to receive every week the newsletter from ':
                        'Deseo recibir el boletín semanal de ',
                    'I’m willing to receive punctual promotions (sales, operations, Antiwaste)':
                        'Deseo recibir promociones puntuales (ventas, operaciones, Antigaspi…).',
                    'I’m willing to receive targeted emails according to my browsing data and my interests':
                        'Deseo recibir correos electrónicos dirigidos según mis datos de navegación e intereses.',
                    'No dispute found': 'No se encontró ninguna disputa',
                    'Old password': 'Contraseña antigua',
                    'New password': 'Nueva contraseña',
                    'Reset your password': 'Restablecer su contraseña',
                    'Confirm password': 'Confirmación de nueva contraseña',
                    'Please validate the login request by clicking the button':
                        'Por favor, valide la solicitud de inicio de sesión haciendo clic en el botón',
                    'Send connection request': 'Enviar solicitud de conexión',
                    'Logged in to machine successfully! You are being redirected to the app…':
                        '¡Conectado a la máquina con éxito! Se le está redirigiendo a la aplicación…',
                    'You need to register at least one paiement method to use the app.':
                        'Debe registrar al menos un método de pago para usar la aplicación.',
                    'Unable to registered your card, please check the information. Please try again.':
                        'No se ha podido registrar su tarjeta, por favor compruebe la información. Por favor, inténtelo de nuevo.',
                    'No refill found': 'No se encontró ninguna recarga',
                    Payment: 'Pago',
                    'Invalid card': 'Tarjeta inválida',
                    'Contact operator of this sale':
                        'Contactar al operador de esta venta',
                    'The application cannot find which client you are trying to create an account for. Please initiate the creation via a QR code or a link sent to you by an operator.':
                        'La aplicación no puede encontrar para qué cliente está intentando crear una cuenta. Inicie la creación a través de un código QR o un enlace enviado por un operador.',
                },
            },
        },
        fallbackLng: 'en-GB',
        debug: process.env.NODE_ENV === 'development',
        // Have a common namespace used around the full app
        ns: ['translations'],
        defaultNS: 'translations',
        keySeparator: false, // We use content as keys
        interpolation: {
            escapeValue: false,
        },
    })

// eslint-disable-next-line unicorn/prefer-export-from
export default i18next
